import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: `/api/sso/login`,
    method: 'post',
    params: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: `/api/sso/info`,
    method: 'get'
  })
}

export function getWishList(memberId) {
  return request({
    url: `/api/product/detail/favor/all?memberId=${memberId}`,
    method: 'get'
  })
}

export function logout() {
  return request({
    url: `/api/sso/logout`,
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: `/api/admin/list`,
    method: 'get',
    params
  })
}

export function createAdmin(data) {
  return request({
    url: `/api/admin/register`,
    method: 'post',
    data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: `/api/admin/update/${id}`,
    method: 'post',
    data
  })
}

export function updateStatus(id, params) {
  return request({
    url: `/api/admin/updateStatus/${id}`,
    method: 'post',
    params
  })
}

export function deleteAdmin(id) {
  return request({
    url: `/api/admin/delete/${id}`,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: `/api/admin/role/${id}`,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: `/api/admin/role/update`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js